import React, { useEffect, useState } from "react";
import { db } from "../config"; // Adjust this path
import { doc, getDoc, setDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import NavBar from "./NavBar"; // Adjust the path if needed

const AdminWalletAddresses = () => {
  const [wallets, setWallets] = useState({
    BITCOIN: "",
    ETHEREUM: "",
    USDT: "",
    USDT_ERC20: "",
    RIPPLE: "",
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchWallets = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "settings", "walletAddresses");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setWallets(docSnap.data());
        }
      } catch (err) {
        console.error("Error fetching wallet addresses:", err);
      }
      setLoading(false);
    };
    fetchWallets();
  }, []);

  const handleChange = (e) => {
    setWallets({ ...wallets, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, "settings", "walletAddresses"), wallets);
      Swal.fire("Success", "Wallet addresses updated successfully.", "success");
    } catch (err) {
      console.error("Error saving wallet addresses:", err);
      Swal.fire("Error", "Failed to update wallet addresses.", "error");
    }
    setSaving(false);
  };

  return (
    <div className="container-fluid">
      {/* Top Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      {/* Custom Navigation Bar */}
      <NavBar />

      <div className="container mt-4">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="card shadow">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0">Admin Wallet Addresses</h4>
              </div>
              <div className="card-body">
                {loading ? (
                  <p>Loading wallet addresses...</p>
                ) : (
                  <>
                    {Object.entries(wallets).map(([key, value]) => (
                      <div className="form-group mb-3" key={key}>
                        <label className="form-label">{key}</label>
                        <input
                          type="text"
                          className="form-control"
                          name={key}
                          value={value}
                          onChange={handleChange}
                          placeholder={`Enter ${key} address`}
                        />
                      </div>
                    ))}
                    <button
                      className="btn btn-success w-100"
                      onClick={handleSave}
                      disabled={saving}
                    >
                      {saving ? "Saving..." : "Save Wallet Addresses"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminWalletAddresses;
